import { Component, Show, createMemo } from 'solid-js'
import Button from '../../shared/Button'
import Modal from '../../shared/Modal'
import { i18nStore, msgStore } from '../../store'

const DeleteMsgModal: Component<{ messageId: string; show: boolean; close: () => void }> = (
  props
) => {
  const i18n = i18nStore((s) => ({ t: s.t }))
  const state = msgStore((s) => ({
    msgs: s.msgs,
    msg: s.msgs.find((msg) => msg._id === props.messageId),
  }))

  const count = createMemo(() =>
    state.msg?.adapter === 'image'
      ? 1
      : state.msgs.length - state.msgs.findIndex(byId(props.messageId))
  )

  const confirm = (one?: boolean) => {
    const deleteOne = one || state.msg?.adapter === 'image'
    msgStore.deleteMessages(props.messageId, deleteOne)
    props.close()
  }

  return (
    <Modal
      title={i18n.t.chat_delete_msg_title}
      show={props.show}
      close={props.close}
      footer={
        <>
          <Button schema="secondary" onClick={props.close}>
            {i18n.t.cancel}
          </Button>
          <Show when={!!state.msg?.retries?.length}>
            <Button onClick={() => msgStore.discardSwipe(props.messageId, 0, props.close)}>
              {i18n.t.chat_delete_swipe}
            </Button>
          </Show>
          <Show when={count() > 1 && state.msg?.adapter !== 'image'}>
            <Button onClick={() => confirm(true)}>{i18n.t.chat_delete_one}</Button>
          </Show>
          <Button schema="red" onClick={() => confirm(false)}>
            {i18n.t.admin_delete} {count()}
          </Button>
        </>
      }
    >
      <Show when={state.msg?.adapter !== 'image'}>
        {i18n.t.chat_delete_msg_confirm.replace('{count}', count().toString())}
        <Show when={count() > 1}>
          <br />
          {i18n.t.chat_delete_msg_one_note}
        </Show>
      </Show>
      <Show when={state.msg?.adapter === 'image'}>
        {i18n.t.chat_delete_msg_image_confirm}
      </Show>
    </Modal>
  )
}

export default DeleteMsgModal

function byId(id: string) {
  return (obj: { _id: string }) => obj._id === id
}
